import { render, staticRenderFns } from "./IconsFinanceSalaryStatus.vue?vue&type=template&id=5568d854&scoped=true&"
import script from "./IconsFinanceSalaryStatus.vue?vue&type=script&lang=js&"
export * from "./IconsFinanceSalaryStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5568d854",
  null
  
)

export default component.exports